import { FC } from 'react'
import { BrowserRouter } from 'react-router-dom'

import { AppProviders } from '@containers/AppProviders/AppProvides'

import { DialogWindowManager } from '@features/DialogWindowManager'
import { GlobalUIOverlay } from '@features/GlobalUIOverlay'

import { AppRoutes } from './AppRoutes'

const App: FC = () => {
  return (
    <AppProviders>
      <BrowserRouter>
        <GlobalUIOverlay />
        <DialogWindowManager />
        <AppRoutes />
      </BrowserRouter>
    </AppProviders>
  )
}

export default App
